import { t } from "ttag";

import type { Appointment } from "@/features/consultations/models";
import { APPOINTMENT_TYPE } from "@/features/consultations/models";
import type { ObjectValue } from "@/shared/models/legacy-types";

const INJECTION_VALUE = {
  TWO_OR_LESS: "2-or-less",
  THREE_OR_MORE: "3-or-more",
  TALK_TO_PROVIDER: "talk-to-provider",
} as const;

export type InjectionValue = ObjectValue<typeof INJECTION_VALUE>;

export interface InjectionFormOption {
  disqualifier: boolean;
  value: InjectionValue;
  label: string;
  appointmentType?: Appointment["type"];
}

export const getFollowUpInjectionFormOptions = (): InjectionFormOption[] =>
  [
    {
      disqualifier: false,
      value: INJECTION_VALUE.TWO_OR_LESS,
      label: t`2 or fewer injections left`,
      appointmentType: APPOINTMENT_TYPE.MEDICATION_REQUEST_FOLLOW_UP,
    },
    {
      disqualifier: true,
      value: INJECTION_VALUE.THREE_OR_MORE,
      label: t`3 or more injections left`,
      appointmentType: APPOINTMENT_TYPE.MEDICATION_REQUEST_FOLLOW_UP,
    },
  ] as const;
